<div class="grid">
    <div class="col-12 md:col-6 xl:col-3 cursor-pointer" (click)="openSidebar()">
        <div class="ss-g-hover-border flex-center" style="height: 160px !important;">
            <i class="pi pi-plus-circle text-5xl mb-2"></i>
            <span class="text-base font-medium">Adicionar</span>

        </div>

    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full" style="height: 160px !important;">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <div class="flex justify-content-between align-items-center">
                    <span class="font-semibold text-lg">
                        <i class="pi pi-clock mr-2"></i> Tempo Assistido
                    </span>
                    <div class="ml-auto">
                        <i class="bi bi-info-circle"
                            pTooltip="Tempo médio de engajamento com o player por sessão (do momento em que abre até fechar), cobrindo fotos e vídeos."
                            tooltipPosition="right" tooltipEvent="focus" tabindex="0"></i>
                    </div>
                </div>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ formatWatchedTime(timeWatched) }}</span>
                        <div [ngClass]="{
                            'text-blue-500': percentageWatched === 0,
                            'text-green-500': percentageWatched > 0,
                            'text-red-500': percentageWatched < 0
                          }">
                            <span class="font-medium">
                                <span *ngIf="percentageWatched == 0">
                                    -
                                </span>
                                <span *ngIf="percentageWatched > 0">
                                    +{{ percentageWatched | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageWatched < 0">
                                    {{ percentageWatched | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                            <!-- <i *ngIf="(porcentagemAguardando ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemAguardando ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->


                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full" style="height: 160px !important;">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <div class="flex justify-content-between align-items-center">
                    <span class="font-semibold text-lg">
                        <i class="bi bi-people-fill mr-2"></i> Visitantes
                    </span>
                    <div class="ml-auto">
                        <i class="bi bi-info-circle"
                            pTooltip="Quantidade total de visitantes que visualizaram os slicks de sua loja (shorts e lives). Contabilizamos apenas 1 visitante ao visualizar um ou mais slicks (não será contabilizado novamente caso o usuário atualize a página ou entre no link novamente)."
                            tooltipPosition="right" tooltipEvent="focus" tabindex="0"></i>
                    </div>
                </div>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ countEspectadores }}</span>

                        <div [ngClass]="{
                            'text-blue-500': percentageEspectadores === 0,
                            'text-green-500': percentageEspectadores > 0,
                            'text-red-500': percentageEspectadores < 0
                          }">
                            <span class="font-medium">
                                <span *ngIf="percentageEspectadores == 0">
                                    -
                                </span>
                                <span *ngIf="percentageEspectadores > 0">
                                    +{{ percentageEspectadores | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageEspectadores < 0">
                                    {{ percentageEspectadores | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full" style="height: 160px !important;">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <div class="flex justify-content-between align-items-center">
                    <span class="font-semibold text-lg">
                        <i class="bi bi-heart-fill mr-2"></i> Likes
                    </span>
                    <div class="ml-auto">
                        <i class="bi bi-info-circle" pTooltip="Quantidade de curtidas de um slick."
                            tooltipPosition="left" tooltipEvent="focus" tabindex="0"></i>
                    </div>
                </div>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ countLikes }}</span>
                        <div [ngClass]="{
                            'text-blue-500': percentageLikes === 0,
                            'text-green-500': percentageLikes > 0,
                            'text-red-500': percentageLikes < 0
                          }">
                            <span class="font-medium">
                                <span *ngIf="percentageLikes == 0">
                                    -
                                </span>
                                <span *ngIf="percentageLikes > 0">
                                    +{{ percentageLikes | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageLikes < 0">
                                    {{ percentageLikes | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                            <!-- <i *ngIf="(porcentagemCanceladas ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemCanceladas ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->

                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <app-slicks-data-view [filteredAssets]="filteredAssets" [sortField]="sortField" [sortOrder]="sortOrder"
                [feedOptions]="feedOptions" [selectedFeeds]="selectedFeeds" (templateClicked)="template($event)"
                (selectedFeedsChange)="selectedFeeds = $event" (onFeedSelect)="onFeedSelect()"
                [tagOptions]="tagOptions" [selectedTags]="selectedFilterTags"
                (selectedTagsChange)="selectedFilterTags = $event" (onTagsSelect)="onTagsSelect()"
                [productOptions]="productOptions" [selectedProducts]="selectedFilterProducts"
                (selectedProductsChange)="selectedFilterProducts = $event" (onProductsSelect)="onProductsSelect()"
                [usageRightsOptions]="usageRightsOptions" [selectedUsageRights]="selectedUsageRights"
                (selectedUsageRightsChange)="selectedUsageRights = $event" (onUsageRightsChange)="onUsageRightsChange()"
                [mediaTypeOptions]="mediaTypeOptions" [selectedMediaTypes]="selectedMediaTypes"
                (selectedMediaTypesChange)="selectedMediaTypes = $event" (onMediaTypeChange)="onMediaTypeChange()"
                [sourceOptions]="sourceOptions" [selectedSources]="selectedSources"
                (selectedSourcesChange)="selectedSources = $event" (onSourceSelect)="onSourceSelect()"
                [typeOptions]="typeOptions" [selectedType]="selectedType" (selectedTypeChange)="selectedType = $event"
                [statusOptions]="statusOptions" [selectedStatus]="selectedStatus"
                (selectedStatusChange)="selectedStatus = $event" [rangeDates]="rangeDates"
                (rangeDatesChange)="rangeDates = $event" [searchTerm]="searchTerm"
                (searchTermChange)="searchTerm = $event" (onTypeSelect)="onTypeSelect()"
                (onStatusSelect)="onStatusSelect()" (onDateSelect)="onDateSelect()"
                (onFilterSlicks)="onFilterSlicks($event)" (clearFilter)="clearFilter()"
                (solicitarFixar)="fixarVideo($event)"
                (slickDeleted)="onSlickDeleted($event)"
                (slicksDeleted)="onSlicksDeleted($event)"
                (slicksPublishStatusChanged)="onSlicksPublishStatusChanged($event)"
                (slicksTagsChanged)="onSlicksTagsChanged()"
                (addSlick)="openSidebar()"></app-slicks-data-view>

        </div>
    </div>
</div>

<p-dialog header="Confirmação" [(visible)]="displayConfirmDialog" [modal]="true" [closable]="false" [resizable]="false"
    class="ss-g-dialog-sized">
    <p *ngIf="!pendingUidIsPinned">Marcando esta opção, este slick se tornará um dos primeiros vídeos do seu Link na Bio. Deseja continuar?</p>
    <p *ngIf="pendingUidIsPinned">Este slick já está fixado. Deseja desafixá-lo?</p>
    <p-footer>
        <button type="button" pButton pRipple [label]="pendingUidIsPinned ? 'Desafixar' : 'Fixar'"
            (click)="confirmFixarVideo()"></button>
        <button type="button" pButton pRipple label="Cancelar" class="p-button-outlined"
            (click)="displayConfirmDialog = false"></button>
    </p-footer>
</p-dialog>
<p-sidebar [modal]="!isMobile" [(visible)]="displaySidebar" (onHide)="closeSidebar()"
    class="ss-g-custom-sidebar-width ss-l-class-metaApp" position="right">
    <ng-template pTemplate="header">
        <h4 style="margin-bottom: 0;">Slicks</h4>
    </ng-template>
    <div class="sidebar-content">
        <app-feed-help [text]="'Slicks'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
            [supportUrl]="'https://meusite.com/suporte'">
        </app-feed-help>
        <div class="mt-2">
            <div class="card shadow-none">
                <div class="flex flex-nowrap gap-2 mb-3">
                    <div class="flex-1 border-1 border-round pt-3 pb-2 px-1 cursor-pointer text-center transition-colors transition-duration-200 surface-border hover:surface-200"
                        (click)="mediaMode = 'upload'">
                        <i class="pi pi-upload text-lg mb-1" style="display:block; height:1.25rem; line-height:1.25rem;"></i>
                        <div class="text-xs font-medium">Upload</div>
                    </div>
                    <div class="flex-1 border-1 border-round pt-3 pb-2 px-1 cursor-pointer text-center transition-colors transition-duration-200 surface-border hover:surface-200"
                        (click)="openGaleria('instagram')">
                        <i class="pi pi-instagram text-lg mb-1" style="display:block; height:1.25rem; line-height:1.25rem;"></i>
                        <div class="text-xs font-medium">Instagram</div>
                    </div>
                    <div class="flex-1 border-1 border-round pt-3 pb-2 px-1 cursor-pointer text-center transition-colors transition-duration-200 surface-border hover:surface-200"
                        (click)="openGaleria('tiktok')">
                        <i class="bi bi-tiktok text-lg mb-1" style="display:block; height:1.25rem; line-height:1.25rem;"></i>
                        <div class="text-xs font-medium">TikTok</div>
                    </div>
                    <div class="flex-1 border-1 border-round pt-3 pb-2 px-1 cursor-pointer text-center transition-colors transition-duration-200 surface-border hover:surface-200"
                        (click)="openGaleria('google')">
                        <i class="pi pi-youtube text-lg mb-1" style="display:block; height:1.25rem; line-height:1.25rem;"></i>
                        <div class="text-xs font-medium">YouTube</div>
                    </div>
                </div>
                <!-- -->

                <div class="flex flex-column mb-2" *ngIf="mediaMode === 'upload'">
                    <label class="w-full ss-g-globalClassLabel">
                        Descrição
                    </label>
                    <div class="mb-2">
                        <textarea rows="3" cols="30" class="w-full p-inputtextarea p-inputtext p-component p-element"
                            placeholder="Descrição do Slick" [(ngModel)]="slickDesc" pInputTextarea></textarea>
                    </div>
                </div>
                <!-- -->
                <div *ngIf="importedItems.length > 0 && mediaMode === 'social'" class="mt-4" [ngClass]="{
                        'ng-invalid': hasError4,
                        'ng-dirty': hasError4,
                        'file-upload-error': hasError4
                     }">
                    <div class="grid">
                        <div class="col-12 md:col-4" *ngFor="let item of importedItems">
                            <div class="card relative p-2">

                                <!-- botão X de remover -->
                                <button pButton icon="pi pi-times"
                                    class="p-button-rounded p-button-text p-button-danger absolute"
                                    style="top: 5px; right: 5px; z-index: 10;" (click)="removeImportedItem(item)">
                                </button>

                                <div class="relative w-full" style="aspect-ratio: 9 / 16;">

                                    <!-- IMAGEM -->
                                    <img *ngIf="item.media_type === 'IMAGE'" [src]="item.media_url" alt="Imagem"
                                        class="absolute inset-0 w-full h-full object-cover border-round" />

                                    <!-- VÍDEO -->
                                    <video *ngIf="item.media_type === 'VIDEO'" [src]="item.media_url"
                                        [poster]="item.thumb_url" controls muted
                                        class="absolute inset-0 w-full h-full object-cover border-round">
                                    </video>

                                    <!-- CARROSSEL -->
                                    <swiper *ngIf="item.media_type === 'CAROUSEL_ALBUM'" [navigation]="false"
                                        [attr.data-uid]="item.id"
                                        class="absolute inset-0 w-full h-full rounded overflow-hidden">
                                        <ng-template swiperSlide *ngFor="let child of item.children?.data">
                                            <ng-container [ngSwitch]="child.media_type">
                                                <img *ngSwitchCase="'IMAGE'" [src]="child.media_url"
                                                    class="w-full h-full object-cover" />
                                                <video *ngSwitchCase="'VIDEO'" [src]="child.media_url" controls muted
                                                    class="w-full h-full object-cover"></video>
                                            </ng-container>
                                        </ng-template>
                                    </swiper>
                                    <ng-container *ngIf="item.media_type === 'CAROUSEL_ALBUM'">
                                        <div class="arrow-toggle-container left-arrow">
                                            <button class="circular-nav-button" pButton pRipple
                                                (click)="slideToPrev(item.id)">
                                                <i class="pi pi-chevron-left"></i>
                                            </button>
                                        </div>

                                        <div class="arrow-toggle-container right-arrow">
                                            <button class="circular-nav-button" pButton pRipple
                                                (click)="slideToNext(item.id)">
                                                <i class="pi pi-chevron-right"></i>
                                            </button>
                                        </div>
                                    </ng-container>

                                </div>


                                <!-- Ícone da fonte  -->
                                <div class="absolute" style="bottom: 8px; left: 8px;z-index: 33;">
                                    <i *ngIf="item.source === 'instagram'"
                                        class="pi pi-instagram text-xl text-pink-500"></i>
                                    <i *ngIf="item.source === 'tiktok'" class="bi bi-tiktok text-xl text-primary"></i>
                                    <i *ngIf="item.source === 'youtube'" class="bi bi-youtube text-xl text-red-600"></i>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Rodapé com contador e limpar -->
                    <div class="flex justify-content-between align-items-center mt-3 px-2">
                        <span class="font-medium text-sm">{{ importedItems.length }} item(s) importado(s)</span>
                        <a href="#" (click)="clearImportedItems(); $event.preventDefault()"
                            class="text-sm text-red-500 font-medium">× Limpar tudo</a>
                    </div>
                </div>
                <div class="flex align-items-center justify-content-between mt-2"
                    *ngIf="importedItems.length > 0 && mediaMode === 'social'">
                    <small *ngIf="hasError4" class="p-error">{{ errorMessage4 || 'Obrigatório' }}</small>
                </div>
                <!-- -->

                <!-- <div class="col-12 mt-3 mb-2 flex flex-column" style="padding: 0;" *ngIf="typeLive"> -->
                <div class="mt-2 mb-2 flex flex-column" *ngIf="mediaMode === 'upload'">
                    <!-- -->
                    <app-upload-file [accept]="'image,video'" [fileName]="selectedFile?.name || null"
                        [previewUrl]="null" [errorSize]="hasSizeError" [errorType]="hasTypeError"
                        (fileSelected)="handleUpload($event)" (fileInvalid)="handleUploadError($event)"
                        (fileValid)="hasError3 = false" (removeFile)="removeVideoAndImage()" [isSlicks]="true"
                        styleClass="border-1 surface-border surface-card border-round">
                    </app-upload-file>
                    <!-- -->

                    <div class="mt-2" *ngIf="uploadProgressVideo > 0" style="position: relative;">
                        <p-progressBar [value]="uploadProgressVideo" class="w-full"></p-progressBar>
                    </div>
                    <div class="mt-2" *ngIf="uploadProgress > 0" style="position: relative;">
                        <p-progressBar [value]="uploadProgress" class="w-full"></p-progressBar>
                    </div>
                </div>

                <div class="flex flex-column mb-2 mt-2 w-full">
                    <label class="w-full ss-g-globalClassLabel">Tags</label>
                    <p-chips [(ngModel)]="selectedTags" class="w-full" (ngModelChange)="updateTagsString()"
                        separator="," placeholder="Insira uma tag e aperte ',' ou ⏎" styleClass="w-full"></p-chips>

                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="closeSidebar()" class="p-button-outlined "></button>
            <button pButton pRipple label="Upload" [loading]="loadingBtn" (click)="uploadSave()" [disabled]="uploadOn"
                class="ml-2 mr-2"></button>

        </div>
    </ng-template>
</p-sidebar>




<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>

<!-- Instância própria (key dedicada) só pro aviso de "novos itens podem
     aparecer" pós-criação de feed — posição bottom, diferente do
     p-confirmDialog global (app.component.html) usado pelas confirmações
     padrão (exclusão etc.), que ficam centralizadas. -->
<p-confirmDialog key="feedCreatedNotice" [position]="'bottom'" [style]="{width: '30rem'}"></p-confirmDialog>

<p-dialog [baseZIndex]="100" class="ss-l-sizeDialogs" header="Usar Como Template" [(visible)]="displayDialogTemplate"
    class="ss-l-sizeDialogs" [modal]="true" id="dialog1" [dismissableMask]="true" (onHide)="resetDialogInputs()">
    <div class="flex flex-column mb-2">
        <label class="w-full ss-g-globalClassLabel">
            Descrição
        </label>
        <div class="mb-2">
            <textarea rows="3" cols="30" class="w-full p-inputtextarea p-inputtext p-component p-element"
                placeholder="Descrição do Slick" [(ngModel)]="slickDescCopy" pInputTextarea></textarea>
        </div>

    </div>
    <div class="flex flex-column">
        <!-- Primeira label sozinha -->
        <div class="align-items-center mb-2">
            <label>mais opções</label>
        </div>

        <!-- Segundo contêiner para os switches e labels -->
        <div class="flex align-items-center mb-2">

            <p-inputSwitch [(ngModel)]="publicarAgoraCopy" class="mr-2" (onChange)="simular()"></p-inputSwitch>
            <label>Publicar Agora</label>
        </div>

    </div>
    <div class="flex align-items-center mt-2 mb-2 w-full" *ngIf="!publicarAgoraCopy">
        <label class="ss-g-globalClassLabel">Data e hora</label>
    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="closeCopyTemplate()" class="p-button-outlined "></button>
            <button pButton pRipple label="Criar" [loading]="isTemplate" (click)="createTemplate()"
                [disabled]="uploadOn" class="ml-2 mr-2"></button>

        </div>
    </ng-template>
</p-dialog>


<p-dialog header="Limite de Slicks Atingido" [(visible)]="displayLimitDialog" [modal]="true" [closable]="false"
    class="ss-g-dialog-sized">
    <p>Você atingiu o limite de 10 Slicks do seu plano. Remova um Slick ou atualize seu plano.</p>
    <p-footer>
        <button type="button" pButton label="Upgrade" icon="pi pi-check" (click)="upgradePlan()"></button>
        <button type="button" pButton label="Ok" icon="pi pi-times" (click)="closeLimitDialog()"></button>
    </p-footer>
</p-dialog>
<router-outlet></router-outlet>





<p-dialog [(visible)]="showGaleriaSidebar" [baseZIndex]="11000" [modal]="true" [closable]="true"
    [dismissableMask]="true" class="dialog2 dialog-galeria ss-g-dialog-sized" apendTo="body" (onHide)="closeGaleria()">
    <ng-template pTemplate="header">
        <div class="flex flex-column p-0">
            <h3 class="p-0 m-0">Importar mídias</h3>
        </div>
    </ng-template>
    <app-feed-help [text]="'importar'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
        [supportUrl]="'https://meusite.com/suporte'">
    </app-feed-help>
    <app-galeria [source]="feedSource" #galeriaRef [enablePanelAdjustment]="true" [showAutoPublish]="showAutoPublish"
        [showContent]="showContent" (hashtagResults)="onHashTagJson($event)" (tagsResults)="onTagsJson($event)"
        (mediaResults)="onMediaJson($event)" (storiesResults)="onStoriesJson($event)"></app-galeria>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton label="Fechar" class="p-button-outlined" (click)="closeGaleria()"></button>
            <button pButton [label]="'Importar (' + galeriaRef?.selectedItems?.length + ')'"
                [disabled]="!galeriaRef?.selectedItems?.length" (click)="importarSelecionados()"
                class="p-button-primary">
            </button>
        </div>
    </ng-template>
</p-dialog>